// These should be overridden by the implementation
const errorHandler = {
  getHTTPErrorHandler: () => {
    /**
     * @param {any} error
     */
    function defaultHandler(error) {
      console.warn('Default HTTP error handler:', error);
      return error;
    }

    return defaultHandler;
  },
};

export default errorHandler;
